export const BEFORE_CLOSE = 'popin-player-before-close';
